import { create } from '~/modules/kiosk/hooks/store.ts';
import { ContactType } from '~/modules/kiosk/hooks/useSelectSessionStore.ts';

type State = {
  isOpen: boolean;
  location: any;
  confetti: string;
  error: string;
  contact: ContactType | null;
};

type Actions = {
  open: () => void;
  close: () => void;
  setLocation: (request: any) => void;
  setError: (msg: string) => void;
  setConfetti: (name: string, callback: () => void) => void;
  setContact: (contact: ContactType | null) => void;
  resetState: () => void;
};

export type KioskStore = State & Actions;

export const useKioskStore = create<KioskStore>((set) => ({
  isOpen: false,
  location: {},
  confetti: '',
  error: '',
  contact: null,

  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
  setLocation: (request) => {
    set(() => ({
      isOpen: false,
      location: request,
    }));
  },

  setContact: (contact) => {
    set(() => ({
      contact,
    }));
  },
  setError: (msg) => {
    set(() => ({
      confetti: '',
      error: msg,
    }));
    setTimeout(
      () =>
        set(() => {
          return {
            error: '',
            contact: null,
          };
        }),
      3000,
    );
  },
  setConfetti: (name, callback) => {
    set(() => ({
      confetti: name,
      error: '',
      name,
    }));
    setTimeout(() => {
      set(() => {
        return {
          confetti: '',
          error: '',
        };
      });
      callback();
    }, 3000);
  },

  resetState: () => {
    set({
      isOpen: false,
      confetti: '',
      error: '',
      contact: null,
    });
  },
}));
